// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson
// Wordloom — the curated dictionary + tile values.
//
// words.txt is a frequency-curated common-word list (scripts/gen-dictionary.mjs), NOT
// a raw Scrabble/SCOWL dump — obscure short words are dropped so the game rewards words
// you actually know. Only lengths 3–6 are present (the longest scoring line is 6). It
// is inlined via Vite `?raw`, so the game is fully offline.

import raw from './data/words.txt?raw';

/** Every scorable word, upper-case. */
export const WORDS: ReadonlySet<string> = new Set(
  raw
    .split('\n')
    .map((w) => w.trim().toUpperCase())
    .filter((w) => w.length >= 3 && w.length <= 6 && /^[A-Z]+$/.test(w)),
);

export function isWord(w: string): boolean {
  return WORDS.has(w.toUpperCase());
}

/** Scrabble-style tile values — rarer letters are worth more. */
export const TILE_VALUE: Readonly<Record<string, number>> = {
  A: 1, E: 1, I: 1, O: 1, U: 1, L: 1, N: 1, S: 1, T: 1, R: 1,
  D: 2, G: 2,
  B: 3, C: 3, M: 3, P: 3,
  F: 4, H: 4, V: 4, W: 4, Y: 4,
  K: 5,
  J: 8, X: 8,
  Q: 10, Z: 10,
};

export function tileValue(ch: string): number {
  return TILE_VALUE[ch.toUpperCase()] ?? 0;
}

export const VOWELS = 'AEIOU';
export function isVowel(ch: string): boolean {
  return VOWELS.includes(ch.toUpperCase());
}
